var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "412.000000pt",
    height: "420.000000pt",
    viewBox: "0 0 412.000000 420.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,420.000000) scale(0.100000,-0.100000)",
    fill: "#C0BFC7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642 3319 c-52 -26 -105 -86 -120 -138 -17 -55 -17 -1333 0 -1399 17 -67 89 -136 158 -151 112 -24 112 -24 190 97 l69 107 -104 3 -105 3 0 639 0 640 1325 0 1325 0 -2 -637 -3 -638 -42 -3 c-24 -2 -43 -7 -43 -12 0 -8 -71 -131 -107 -187 l-17 -25 135 4 c125 3 138 5 181 31 56 33 92 77 107 132 7 27 11 253 11 696 0 742 1 728 -71 794 -78 70 33 65 -1476 65 l-1368 0 -43 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016 2433 c124 -117 165 -226 140 -371 -17 -97 -62 -190 -191 -392 -103 -161 -175 -296 -194 -365 -14 -51 -14 -169 0 -220 15 -54 77 -143 139 -198 l52 -47 173 0 172 0 -67 68 c-85 88 -120 156 -127 254 -10 142 32 244 225 538 130 198 189 352 179 464 -8 89 -63 191 -139 260 l-61 56 -176 0 -176 0 51 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 2413 c116 -119 152 -240 116 -383 -19 -75 -95 -223 -188 -365 -172 -266 -217 -376 -205 -508 9 -101 84 -223 180 -294 29 -22 40 -23 200 -23 l170 0 -70 73 c-78 82 -110 140 -122 219 -21 132 27 269 173 493 101 155 146 232 185 320 34 75 36 86 36 185 0 100 -2 108 -34 167 -18 35 -60 90 -93 123 l-60 60 -177 0 -177 0 66 -67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706 2433 c64 -61 120 -143 135 -196 15 -55 6 -199 -15 -258 -20 -57 -92 -188 -161 -294 -88 -134 -141 -226 -176 -305 -31 -70 -33 -82 -34 -185 0 -102 2 -114 29 -165 16 -30 59 -85 96 -122 l68 -68 176 0 175 0 -67 68 c-86 86 -124 161 -130 257 -8 134 30 227 205 502 166 262 213 380 198 507 -10 87 -49 160 -127 239 l-68 67 -177 0 -177 0 50 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 1753 c-29 -49 -59 -98 -68 -110 l-14 -23 84 0 84 0 63 97 c35 53 65 103 68 110 4 10 -15 13 -80 13 l-85 0 -52 -87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2411 1762 c-25 -42 -53 -88 -63 -101 -10 -13 -18 -28 -18 -32 0 -5 36 -9 79 -9 l80 0 25 38 c39 56 97 144 107 164 9 17 3 18 -78 18 l-88 0 -44 -78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/Glass.e2e97648b52ca5008b2841df92aa9d19.svg";
export { ForwardRef as ReactComponent };